export function SuccessEmail() {
  return (
    <div
      className="d-flex flex-column align-items-center text-center p-3"
      style={{ gap: '2rem' }}
    >
      <img
        src="/svgs/mail-sent.svg"
        alt="Logo Alerta Rolante"
        style={{ width: '14rem', height: '14rem' }}
      />
      <span className="title">E-mail enviado com sucesso!</span>
    </div>
  );
}
